import RapiDocReact from "./RapiDocReact";

export default function Docs({token}) {
  return (
    <RapiDocReact
      specLoaded={(spec) => {
      }}
      spec-url = "./retain.json" 
      id="thedoc" 
      theme = "light"
      render-style="read" 
      schema-style="table"
      show-method-in-nav-bar = "true"
      use-path-in-nav-bar = "true"
      show-components = "true"
      show-info = "true"
      sort-endpoints-by = "method"
      show-header = "false"
      allow-search = "false"  
      allow-advanced-search = "false"
      allow-spec-url-load="false"
      allow-spec-file-download="false"
      allow-server-selection = "false"
      allow-authentication	= "false"
      update-route="false"
      match-type="regex"
      persist-auth="true"
      scroll-behavior="smooth"
      api-key-name = "Authorization"
      api-key-location = "header"
      api-key-value={"Bearer " + token}
      bg-color="#EEEFF2"
      nav-bg-color="#192C3E"
      primary-color="#018848"
    />
  );
}
